import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const DuplicateContentModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "DuplicateContentModalContainer" */
      './DuplicateContentModalContainer'
    ),
  loading: LoadingModal,
});
